import { render, staticRenderFns } from "./HospitalLevelAdd.form.vue?vue&type=template&id=30f4c4f2&"
import script from "./HospitalLevelAdd.form.vue?vue&type=script&lang=js&"
export * from "./HospitalLevelAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports